
const FounderStatement = () => {
  return (
    <section className="py-32 bg-white">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="relative">
              <div className="w-96 h-96 bg-juv-soft-blush/30 rounded-full mx-auto"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-48 h-48 bg-juv-terracotta/20 rounded-full flex items-center justify-center">
                  <div className="w-32 h-32 bg-juv-deep-chestnut/10 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <blockquote className="text-3xl md:text-4xl font-serif italic text-juv-deep-chestnut leading-relaxed mb-8">
              "At JUV, we blend cutting-edge technology with personalized care to transform your dental experience."
            </blockquote>
            
            <div>
              <p className="text-xl font-semibold text-juv-terracotta mb-2">Dr. Parth Kansagra</p>
              <p className="text-juv-deep-chestnut/70">Founder & Medical Director</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStatement;
